import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-grade-small-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.487 8.839a.303.303 0 0 0-.43 0L8.84 13.059l-.001.001a.302.302 0 0 0-.088.214v1.977h1.977c.08 0 .158-.032.215-.09l4.218-4.217a.304.304 0 0 0 0-.43l-1.673-1.674Zm-2.76 7.911H8a.75.75 0 0 1-.75-.75v-2.727c0-.477.189-.937.53-1.277l4.217-4.217a1.803 1.803 0 0 1 2.552 0l1.672 1.672a1.803 1.803 0 0 1 0 2.552m0 0-4.218 4.218a1.806 1.806 0 0 1-1.276.529"
    }, null, -1)
  ])))
}
export default { render: render }